(function () {
  const CONFIG = {
    apiBase: "https://huggah-chatbot.onrender.com",
    title: "Huggah Asistan",
    subtitle: "Nazik ve hızlı destek 🤍",
    welcome:
      "Merhaba 🤍 Size yardımcı olmaktan memnuniyet duyarım. Önce kısa bir bilgi alalım, ardından sorularınızı yanıtlayayım.",
    firstBotMessage:
      "Huggah ürünleri, içerikleri, kullanım alanları, kargo, kampanya ve genel site bilgileri hakkında yardımcı olabilirim 🌿"
  };

  const root = document.createElement("div");
  root.id = "huggah-chatbot-root";
  root.innerHTML = `
    <button class="hc-toggle" aria-label="Chat aç">🎧</button>
    <div class="hc-panel">
      <div class="hc-header">
        <div class="hc-header-left">
          <span>${CONFIG.title}</span>
          <span class="hc-header-sub">${CONFIG.subtitle}</span>
        </div>
        <button class="hc-close" aria-label="Kapat">✕</button>
      </div>
      <div class="hc-body" id="hc-body"></div>
      <div class="hc-footer" id="hc-footer"></div>
    </div>
  `;
  document.body.appendChild(root);

  const toggle = root.querySelector(".hc-toggle");
  const panel = root.querySelector(".hc-panel");
  const body = root.querySelector("#hc-body");
  const footer = root.querySelector("#hc-footer");
  const closeBtn = root.querySelector(".hc-close");

  const sessionId =
    localStorage.getItem("huggah_chat_session") || crypto.randomUUID();
  localStorage.setItem("huggah_chat_session", sessionId);

  const HISTORY_KEY = "huggah_chat_history";

  let lead = {
    leadId: localStorage.getItem("huggah_lead_id") || null,
    name: localStorage.getItem("huggah_lead_name") || "",
    phone: localStorage.getItem("huggah_lead_phone") || "",
    started: !!localStorage.getItem("huggah_lead_started")
  };

  let typingEl = null;

  function getHistory() {
    try {
      return JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]");
    } catch {
      return [];
    }
  }

  function saveHistory(history) {
    localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
  }

  function pushHistory(item) {
    const history = getHistory();
    history.push(item);
    saveHistory(history.slice(-30));
  }

  function currentPage() {
    return window.location.href;
  }

  function scrollToBottom() {
    body.scrollTop = body.scrollHeight;
  }

  function stripRawUrls(text = "") {
    return String(text)
      .replace(/https?:\/\/[^\s]+/g, "")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  }

  function createLinkCards(links) {
    if (!Array.isArray(links) || !links.length) return null;

    const wrap = document.createElement("div");
    wrap.className = "hc-links";

    links.forEach((item) => {
      const isProduct = item.type === "product";

      const card = document.createElement("div");
      card.className = "hc-card";

      if (isProduct && item.image) {
        const img = document.createElement("img");
        img.className = "hc-card-img";
        img.src = item.image;
        img.alt = item.title || "Huggah";
        card.appendChild(img);
      }

      const cardBody = document.createElement("div");
      cardBody.className = "hc-card-body";

      const title = document.createElement("span");
      title.className = "hc-card-title";
      title.textContent = item.title || "Bağlantı";

      const subtitle = document.createElement("span");
      subtitle.className = "hc-card-subtitle";
      subtitle.textContent = item.subtitle || "Detay sayfası";

      const actions = document.createElement("div");
      actions.className = "hc-card-actions";

      const primary = document.createElement("a");
      primary.className = "hc-card-btn primary";
      primary.href = item.ctaPrimaryUrl || item.url || "#";
      primary.target = "_blank";
      primary.rel = "noopener noreferrer";
      primary.textContent = item.ctaPrimary || "İncele";

      actions.appendChild(primary);
      cardBody.appendChild(title);
      cardBody.appendChild(subtitle);
      cardBody.appendChild(actions);
      card.appendChild(cardBody);
      wrap.appendChild(card);
    });

    return wrap;
  }

  function addMessage(text, sender = "bot", links = [], save = true) {
    const wrap = document.createElement("div");
    wrap.className = `hc-message ${sender}`;

    const textDiv = document.createElement("div");
    textDiv.className = "hc-message-text";
    textDiv.textContent = sender === "bot" ? stripRawUrls(text) : text;
    wrap.appendChild(textDiv);

    if (sender === "bot") {
      const cards = createLinkCards(links);
      if (cards) wrap.appendChild(cards);
    }

    body.appendChild(wrap);
    scrollToBottom();

    if (save) {
      pushHistory({
        text: sender === "bot" ? stripRawUrls(text) : text,
        sender,
        links
      });
    }
  }

  function renderSavedHistory() {
    const history = getHistory();
    history.forEach((item) => {
      addMessage(item.text, item.sender, item.links || [], false);
    });
  }

  function showTyping() {
    if (typingEl) return;

    typingEl = document.createElement("div");
    typingEl.className = "hc-message bot hc-typing";
    typingEl.innerHTML = `
      <span class="hc-typing-bubble">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `;
    body.appendChild(typingEl);
    scrollToBottom();
  }

  function hideTyping() {
    if (typingEl) {
      typingEl.remove();
      typingEl = null;
    }
  }

  function saveLeadLocal() {
    if (lead.leadId) localStorage.setItem("huggah_lead_id", lead.leadId);
    if (lead.name) localStorage.setItem("huggah_lead_name", lead.name);
    if (lead.phone) localStorage.setItem("huggah_lead_phone", lead.phone);
    if (lead.started) localStorage.setItem("huggah_lead_started", "1");
  }

  function renderLeadForm() {
    body.innerHTML = "";
    footer.innerHTML = "";

    const isProductPage = currentPage().includes("/products/");
    const pageHint = isProductPage
      ? "İsterseniz bulunduğunuz ürün sayfasıyla ilgili de yardımcı olabilirim ✨"
      : "İsterseniz ürünler, kargo ya da kampanyalar hakkında soru sorabilirsiniz ✨";

    addMessage(`${CONFIG.welcome}\n${pageHint}`, "bot");

    const form = document.createElement("form");
    form.className = "hc-form";
    form.innerHTML = `
      <input class="hc-input" name="name" placeholder="Adınız Soyadınız" required />
      <input class="hc-input" name="phone" placeholder="Cep Telefonunuz" required />
      <label class="hc-consent">
        <input type="checkbox" name="consent" required />
        <span>Kişisel verilerimin destek ve iletişim amacıyla işlenmesini kabul ediyorum.</span>
      </label>
      <button class="hc-btn" type="submit">Sohbeti Başlat</button>
    `;

    footer.appendChild(form);

    form.addEventListener("submit", async function (e) {
      e.preventDefault();

      const fd = new FormData(form);
      const payload = {
        name: String(fd.get("name") || "").trim(),
        phone: String(fd.get("phone") || "").trim(),
        consent: !!fd.get("consent"),
        sourcePage: currentPage()
      };

      try {
        const res = await fetch(`${CONFIG.apiBase}/api/lead`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        const data = await res.json();
        if (!res.ok) {
          alert(data.error || "Form gönderilemedi.");
          return;
        }

        lead = {
          ...lead,
          ...payload,
          leadId: data.leadId,
          started: true
        };
        saveLeadLocal();

        body.innerHTML = "";
        renderChat();
        addMessage(CONFIG.firstBotMessage, "bot");
      } catch (err) {
        alert("Bağlantı kurulamadı. Lütfen tekrar deneyin.");
      }
    });
  }

  function renderChat() {
    footer.innerHTML = `
      <form class="hc-chat-form" id="hc-chat-form">
        <div class="hc-input-row">
          <textarea class="hc-textarea" name="message" placeholder="Sorunuzu yazın..."></textarea>
          <button class="hc-btn hc-send-btn" type="submit">Gönder</button>
        </div>
      </form>
    `;

    const form = footer.querySelector("#hc-chat-form");
    const textarea = form.querySelector("textarea");
    const button = form.querySelector("button");

    textarea.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        form.requestSubmit();
      }
    });

    form.addEventListener("submit", async function (e) {
      e.preventDefault();

      const message = textarea.value.trim();
      if (!message) return;

      addMessage(message, "user");
      textarea.value = "";
      button.disabled = true;
      showTyping();

      try {
        const res = await fetch(`${CONFIG.apiBase}/api/chat`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            message,
            leadId: lead.leadId,
            name: lead.name,
            phone: lead.phone,
            sessionId,
            sourcePage: currentPage()
          })
        });

        const data = await res.json();
        hideTyping();

        if (!res.ok) {
          addMessage(data.error || "Şu anda yanıt veremiyorum 🤍", "bot");
          return;
        }

        addMessage(data.answer, "bot", data.links || []);
      } catch (err) {
        hideTyping();
        addMessage(
          "Şu anda teknik bir aksaklık oluştu 🤍 Notunuzu aldım, gerekli olursa telefon bilginiz üzerinden size ulaşılabilir. Dilerseniz iletişim veya WhatsApp üzerinden de bize ulaşabilirsiniz.",
          "bot"
        );
      } finally {
        button.disabled = false;
      }
    });
  }

  function init() {
    if (lead.started) {
      body.innerHTML = "";
      renderSavedHistory();
      renderChat();

      if (!getHistory().length) {
        addMessage(CONFIG.firstBotMessage, "bot");
      }
    }
  }

  init();

  closeBtn.addEventListener("click", function () {
    panel.classList.remove("open");
  });

  toggle.addEventListener("click", function () {
    panel.classList.toggle("open");

    if (panel.classList.contains("open") && !lead.started) {
      renderLeadForm();
    } else if (panel.classList.contains("open") && lead.started) {
      body.innerHTML = "";
      renderSavedHistory();
      renderChat();
    }
  });
})();